module.exports = __webpack_public_path__ + "static/media/damagingwind-icon.d1fbd384.svg";